import { initialsRender } from '../../../../../common/functions/renderers/initialsRender';

export const pocRender = (e) => {
    const poc = e.data.poc;

    // If poc is missing entirely
    if (!poc) {
        return;
    }

    return initialsRender(poc.firstName, poc.lastName);
};
